<template>
    <div class="introductionBox">
       <businessBanner tabIndex="1"></businessBanner>
       <div :class="isMobile?'mobileShow':'mainShow'">
        <p class="font20 fontw">前期咨询</p>
        <p class="mt36 jies">集团前期咨询业务开展于2004年，经过多年的潜心发展，如今已成为资信水平优良，技术力量雄厚，业绩能力突出的综合型咨询业务。</p>
       </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl cont'">
                    <div :class="isMobile?'contTM':'contT'">专项资信</div>
                    <p>建筑，电子、信息工程（含通信、广电、信息化），石化、化工、医药，机械（含智能制造），轻工、纺织，市政公用工程等六项专业甲级以及PPP咨询专项甲级等资信。</p>
                    <p class="erhP">生态建设工程和环境工程；农业、林业；水利水电；电力（含火电、水电、核电、新能源）；建材；其他（节能）等六项专业乙级资信。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr jiajImg'" src="@/assets/businessScope/jiaj.png" alt="">
            </div>
       </div>
       <div :class="isMobile?'mainM':'main clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':'contT'">项目类型</p>
            <img :class="isMobile?'contImgShow':'fl xmImg'" src="@/assets/businessScope/xingm.png" alt="">
            <div :class="isMobile?'contM':'fr contd'">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">项目类型</div>
                <p>集团前期咨询项目年立项1000余项，项目类型涵盖规划咨询、项目咨询、评估咨询、专项评价以及综合决策咨询与管理等，咨询产品共计70项。</p>
            </div>
        </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl contLeft'">
                    <div :class="isMobile?'contTM':'contT'">业务荣誉</div>
                    <p>凭借优良的资信水平、突出的业务能力以及丰富的业绩案例，集团获得了多项国家及省级行业权威机构认可：中国工程咨询协会特邀常务理事、河北省工程咨询协会常务理事、苏州市工程咨询协会会长单位。并多次获得国家及省市级工程咨询优秀成果奖项：全国优秀工程咨询成果二等奖、三等奖、优秀奖；河北省优秀工程咨询成果一等奖、二等奖、三等奖；湖北省优秀工程咨询成果一等奖；苏州市优秀工程咨询成果一等奖、二等奖、三等奖等。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr demo'" src="@/assets/businessScope/demo1.png" alt="">
            </div>
       </div>
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
	export default {
		name:'EarlierConsultation',
        components:{businessBanner},
        data() {
            return {
                
            }
        },
        mounted() {
           
        }
	}
</script>

<style scoped>
    .introductionBox{
        padding-bottom: 50px;
    }
    .mainShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 42px;
    }
    .mobileShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 20px;
    }
    .main{
        width: 1200px;
        margin: 0 auto;
        padding-top:47px;
        padding-bottom: 56px;
    }
    .mainM{
        width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
    .jies{
        line-height: 30px;
        text-indent: 2em;
    }
    .cont{
        width: 525px;
        color: #666;
    }
    .contM{
        width: 100%;
        color: #666;
        line-height: 30px;
    }
    .contM p{
        text-indent: 2em;
    }
    .contT{
        color: #247CD6;
        font-size: 28px;
        margin-top: 60px;
        margin-bottom: 31px;
    }
    .contTM{
        color: #247CD6;
        font-size: 28px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .contT+p{
        line-height: 36px;
        text-indent: 2em;
    }
    .contTM+p{
        line-height: 30px;
        text-indent: 2em;
    }
    .erhP{
        line-height: 36px;
        margin-top: 10px;
        text-indent: 2em;
    }
    .jiajImg{
        width: 637px;
    }
    .contImgShow{
        max-width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .xmImg{
        width: 641px;
    }
    .contd{
        width: 520px;
        color: #666;
    }
    .contLeft{
        width: 601px;
        color: #666;
    }
    .demo{
        width: 555px;
        display: block;
        margin-top: 16px;
    }
</style>